import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "availability-area" }
const _hoisted_2 = { class: "container mw-1780" }
const _hoisted_3 = { class: "availability-wrap" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = {
  class: "col-lg-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_6 = { class: "availability-form text-center text-lg-end" }
const _hoisted_7 = { class: "text-body mt-3 mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("div", {
            class: "col-lg-6",
            "data-aos": "fade-up",
            "data-aos-duration": "1000",
            "data-aos-delay": "100"
          }, [
            _createElementVNode("div", { class: "availability-content" }, [
              _createElementVNode("h3", null, "تريد تجربة السيرفر قبل الاشتراك؟ نوفر لك تجربة مجانية!"),
              _createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
                _createElementVNode("span", { class: "d-block mt-2 mt-sm-0" }, " تواصل معنا الآن واحصل على خطة تجريبية مجانية تماماً للتأكد من الجودة والثبات. ")
              ])
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mb-3 fs-5 fw-bold text-white" }, "اضغط على الزر أدناه لبدء التجربة الفورية:", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("a", {
                href: "https://wa.me/447429916178",
                target: "_blank",
                class: "btn active d-inline-flex align-items-center justify-content-center px-5 py-3 w-100 position-relative",
                style: {"background-color":"#25D366","border-color":"#25D366","color":"#fff","font-size":"18px"}
              }, [
                _createElementVNode("i", { class: "ti ti-brand-whatsapp me-2 fs-4" }),
                _createElementVNode("span", { class: "border-style" }, "اطلب تجربتك المجانية عبر الواتساب")
              ], -1)),
              _createElementVNode("p", _hoisted_7, [
                _cache[1] || (_cache[1] = _createTextVNode(" لديك اشتراك بالفعل؟ ", -1)),
                _createVNode(_component_RouterLink, { to: "/contact-us" }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("تواصل معنا لتجديد اشتراكك.", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}